export default {
  welcome: 'DreamCard Management System',
  greeting: 'Hello, {name}!'
};
